/**
 * Checks if a contract has a valid exchange for trading.
 * Returns false if either exchange or primaryExchange is "VALUE".
 *
 * The "VALUE" exchange represents non-tradable or restricted instruments
 * that should not be shown to users during stock search.
 */
export const isValidExchange = (contract: {
  exchange?: string;
  primaryExchange?: string;
}): boolean => {
  const exchange = (contract.exchange || "").toUpperCase();
  const primaryExchange = (contract.primaryExchange || "").toUpperCase();
  return exchange !== "VALUE" && primaryExchange !== "VALUE";
};
